export const taskStatuses = {
  Progress: 'Выполняется',
  Completed: 'Завершено',
  Error: 'Завершено с ошибкой'
}

export const taskCategories = {
  encoding: 'Транскодирование',
  download: 'Загрузка по ссылке',
  s3multipart: 'S3 мультипарт'
}

export const userSections = {
  api: 'API',
  playlists: 'Вещание',
  recorder: 'Потоки',
  private_files: 'Приватные файлы'
}

export const sectionsSite = [
  {
    name: 'dns',
    title: 'DNS',
    text: 'Централизованное управление доменными зонами и записями для вашей инфраструктуры.',
    icon: 'cloud-dns',
    perm: 'dns'
  },
  {
    name: 'storage',
    title: 'Медиахранилище',
    text: 'Трёхкратное резервирование вашего контента, HTML5 плеер, монетизация контента.',
    icon: 'cloud-computing',
    perm: 'filespot'
  },
  {
    name: 'S3',
    title: 'S3 хранилище',
    text: 'S3-объектное хранилище, для хранения больших объёмов данных и бэкапов инфраструктуры.',
    icon: 'cloud-s3',
    perm: 's3'
  },
  {
    name: 'streams',
    title: 'Запись видеопотоков',
    text: 'Запись ваших трансляций по расписанию или по клику.',
    icon: 'cloud-record',
    perm: 'streamer'
  },
  {
    name: 'channels',
    title: 'Вещание',
    text: 'Формирование прямого эфира из видеофайлов в заданном порядке.',
    icon: 'cloud-publish'
  },
  {
    name: 'tasks',
    title: 'Просмотр задач',
    text: 'Просмотр задач в режиме реального времени.',
    icon: 'tasks'
  },
  {
    name: 'cdn-stats',
    title: 'Статистика CDN',
    text: 'Информация по трафику, хранению и конвертации вашего контента.',
    icon: 'cloud-stats',
    perm: 'cdnvideo'
  },
  {
    name: 'settings',
    title: 'Настройки',
    text: 'Настройки автоматической обработки файлов, просмотр профиля и коллег.',
    icon: 'settings'
  }
  // {
  //   name: 'feedback',
  //   title: 'Задать вопрос',
  //   text: 'По всем вопросам свяжитесь с нами любым удобным способом',
  //   icon: 'cloud-feedback'
  // }
]

export const effectOpts = [
  {
    value: true,
    label: 'Разрешено'
  },
  {
    value: false,
    label: 'Запрещено'
  }
]

export const processStatuses = {
  processing: 'Processing',
  error: 'Error',
  completed: 'Completed',
  finalize: 'Finalize'
}
